import { render } from "./SelectLocation.vue?vue&type=template&id=b1332a22&scoped=true"
import script from "./SelectLocation.vue?vue&type=script&lang=js"
export * from "./SelectLocation.vue?vue&type=script&lang=js"

import "./SelectLocation.vue?vue&type=style&index=0&id=b1332a22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1332a22"]])

export default __exports__